var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBundles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3662_6833)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3662_6833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4302 39.1032C35.4302 41.3518 35.9611 43.4739 36.8969 45.3632C36.95 45.3632 37.0097 45.3566 37.0628 45.3566C37.7928 45.3566 38.5096 45.4164 39.213 45.5096C38.702 44.9242 38.4897 44.5051 38.4697 44.4585C37.6203 42.7488 37.1889 40.9061 37.1889 38.9902C37.1889 32.1847 42.7105 26.6498 49.4998 26.6498C56.2891 26.6498 61.8107 32.1847 61.8107 38.9902C61.8107 40.8928 61.3793 42.7355 60.5232 44.4651C60.5033 44.5117 60.3108 44.9375 59.8994 45.4963C60.563 45.4098 61.2466 45.3566 61.9368 45.3566C61.9899 45.3566 62.043 45.3632 62.1027 45.3632C63.0385 43.4739 63.5761 41.3584 63.5761 39.1032C63.5694 31.3132 57.2713 25 49.4998 25C41.7283 25 35.4302 31.3132 35.4302 39.1032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4322 49.6274L38.8083 50.5122H35.8218L35.1515 49.5542C29.7294 50.4722 25.5815 55.2021 25.5815 60.8967C25.5815 67.2431 30.7382 72.4121 37.0695 72.4121C43.4009 72.4121 48.5575 67.2431 48.5575 60.8967C48.5575 55.3618 44.6353 50.725 39.4322 49.6274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0696 46.7935C29.2981 46.7935 23 53.1067 23 60.8967C23 68.6868 29.2981 75 37.0696 75C44.8411 75 51.1392 68.6868 51.1392 60.8967C51.1392 53.1067 44.8411 46.7935 37.0696 46.7935ZM37.0696 73.1306C30.3401 73.1306 24.8649 67.6423 24.8649 60.8967C24.8649 54.1511 30.3401 48.6628 37.0696 48.6628C43.7991 48.6628 49.2744 54.1511 49.2744 60.8967C49.2744 67.6423 43.7991 73.1306 37.0696 73.1306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4874 45.7426C44.1508 46.5742 47.3231 48.7163 49.4999 51.6434C51.7298 48.6364 55.0216 46.4611 58.8111 45.6761C59.5279 44.9111 59.8398 44.2192 59.873 44.1527C60.6893 42.5095 61.0941 40.7732 61.0941 38.9837C61.0941 33.3557 57.0856 28.6591 51.7763 27.5947L51.0662 28.6058H48.0797L47.3563 27.5747C41.9873 28.5859 37.9058 33.3158 37.9058 38.9837C37.9058 40.7865 38.3106 42.5228 39.1136 44.1394C39.1203 44.1527 39.4786 44.8645 40.4808 45.7426H40.4874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9303 46.7935C57.1188 46.7935 52.878 49.215 50.3428 52.9071C50.7343 53.559 51.0794 54.2509 51.3781 54.9627C51.6635 54.3241 51.9289 53.9382 51.9621 53.8916C54.4641 50.2527 58.7646 48.2171 63.1713 48.583C69.2704 49.0952 74.1085 54.0979 74.427 60.2315C74.6062 63.6641 73.4116 66.9172 71.0623 69.4052C68.7129 71.8932 65.534 73.257 62.1161 73.257C58.6983 73.257 55.5326 71.8866 53.1832 69.4052C52.4267 68.6069 51.836 67.6756 51.4378 66.6844C51.1259 67.4494 50.7675 68.1878 50.3428 68.893C52.878 72.5851 57.1188 75.0066 61.9303 75.0066C69.7018 75.0066 75.9999 68.6934 75.9999 60.9034C75.9999 53.1133 69.7018 46.8001 61.9303 46.8001V46.7935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7011 68.9064C55.9177 71.2414 58.9042 72.532 62.1163 72.532C65.3284 72.532 68.3215 71.2414 70.5382 68.9064C72.7548 66.5714 73.8764 63.5046 73.7105 60.2715C73.4317 54.9495 69.536 50.5389 64.4325 49.5012L63.7224 50.519H60.7359L59.9859 49.4546C56.9995 50.0001 54.3448 51.7031 52.5529 54.3042C52.5397 54.3175 52.1083 54.9562 51.7632 55.9873C52.2808 57.5307 52.5729 59.1805 52.5729 60.8968C52.5729 62.6132 52.3074 64.1033 51.8362 65.5802C52.1614 66.8042 52.7985 67.9551 53.7011 68.9064Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3662_6833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3662_6833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 50,
    fill: "white",
    transform: "translate(23 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundles);
export default __webpack_public_path__ + "static/media/bundles.c24aa9524ab98c2333f745a9a320bce6.svg";
export { ForwardRef as ReactComponent };